import StatsWidgets from "@rio-cloud/rio-uikit/components/statsWidget/StatsWidgets";
import StatsWidget from '@rio-cloud/rio-uikit/StatsWidget';
import StatsWidgetSpacer from '@rio-cloud/rio-uikit/StatsWidgetSpacer';
import StatsWidgetNumber from '@rio-cloud/rio-uikit/StatsWidgetNumber';
import ContentLoader from '@rio-cloud/rio-uikit/ContentLoader';
import { valueStringFormat } from '../../shared/utils/formatters';
import useScoreExtractStore from "../../services/scoreExtractStore";
import useScoreStore from "../../services/scoreStore";
import { useSelectVehicleStore } from "../../services/selectVehicleSlice";
import { useLocation, useNavigate } from "react-router";
import { RouteMap } from "../../routes/routeList";
import useRelationshipStore from "../../services/relationshipStore";
import style from './MainStateCard.module.css'

const mainStateCard = () => {

    const { data: extractScore, loading: extractDataLoading } = useScoreExtractStore();
    const { data: relationshipScore } = useRelationshipStore();
    const { data: score } = useScoreStore();
    const { clearExtractScoreData } = useScoreExtractStore();
    const { clearSelectedVehicle } = useSelectVehicleStore();
    const navigate = useNavigate();
    const location = useLocation();
    const behaviorRoute = `/${RouteMap.get('behavior')}`;
    const relationshipRoute = `/${RouteMap.get('relationship')}`;

    return (
        <StatsWidgets>

            <StatsWidget>
                {(() => {
                    if (extractDataLoading) {
                        return (
                            <StatsWidget.Header>
                                <ContentLoader className='height-20 margin-bottom-10' width={100} />
                            </StatsWidget.Header>
                        )
                    } else {
                        return (
                            <StatsWidget.Header>RIO Truck Score</StatsWidget.Header>
                        )
                    }
                })()}
                <StatsWidget.Body fullWidth>
                    <div className={location.pathname.includes(behaviorRoute) ? style['border-active-status'] : ''}>
                        {(() => {
                            if (extractDataLoading) {
                                return (
                                    <div>
                                        <div>
                                            <ContentLoader className='height-20 margin-bottom-10' width={100} />
                                        </div>
                                        <div>
                                            <ContentLoader className='height-20' width={100} />
                                        </div>
                                    </div>
                                )
                            } else {

                                let behaviorValue = 0
                                if (score?.behavior) {
                                    behaviorValue = score?.behavior
                                }
                                if (extractScore?.behavior) {
                                    behaviorValue = extractScore?.behavior
                                }
                                const isClickable = !location.pathname.includes(behaviorRoute)
                                return (
                                    <StatsWidgetNumber clickable={isClickable} onClick={() => {
                                        if (isClickable) {
                                            clearExtractScoreData();
                                            clearSelectedVehicle();
                                            navigate(behaviorRoute);
                                        }
                                    }} value={valueStringFormat(behaviorValue)} label='Comportamento' />
                                )

                            }
                        })()}
                    </div>
                    <StatsWidgetSpacer />
                    <div className={location.pathname.includes(relationshipRoute) ? style['border-active-status'] : ''}>
                        {(() => {
                            if (extractDataLoading) {
                                return (
                                    <div>
                                        <div>
                                            <ContentLoader className='height-20 margin-bottom-10' width={100} />
                                        </div>
                                        <div>
                                            <ContentLoader className='height-20' width={100} />
                                        </div>
                                    </div>
                                )
                            } else {
                                const isClickable = !location.pathname.includes(relationshipRoute);
                                return (
                                    <StatsWidgetNumber clickable={isClickable} onClick={() => {
                                        if (isClickable) {
                                            navigate(relationshipRoute);
                                        }
                                    }} value={`${relationshipScore?.relationship.value}/${relationshipScore?.relationship.max}`} label='Relacionamento' />)
                            }
                        })()}
                    </div>
                    <StatsWidgetSpacer />
                    <StatsWidgetNumber className='StatsWidgetNumber-label-disabled StatsWidgetNumber-value-disabled' value='0' label='Parceria' />
                </StatsWidget.Body>
            </StatsWidget>
        </StatsWidgets>
    )
}

export default mainStateCard;